module.exports = __webpack_public_path__ + "static/media/close.d7e70123.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Assets/close.svg
// module id = 3
// module chunks = 1